(function() {

	var SearchPage = function() {
		this.initFacets();
		this.initSorting();
		this.initAddToCart();
		this.initCompare();
		C.clamp();
	};

	SearchPage.prototype = {
		initFacets: function() {
			$('.product-search-filters .checkbox-facet').on('click', function() {
				window.location = $(this).data('url');
			});
			
			// View More options
			$('.product-search-filters .more-options').on('click', function() {
				$('.product-search-filters .hidden-option-' + $(this).data('name')).show();
				$(this).hide();
				$('.product-search-filters #less-options-' + $(this).data('name')).show();
			});

			// View Less options
			$('.product-search-filters .less-options').on('click', function() {
				$('.product-search-filters .hidden-option-' + $(this).data('name')).hide();
				$(this).hide();
				$('.product-search-filters #more-options-' + $(this).data('name')).show();
			});
			
			// If a selected option is hidden on page load, click the 'View More' link
			$('.product-search-filters .hidden-option .checkbox-facet:checked').each(function() {
				if (!$(this).is(':visible')) {
					$(this).parents('.list-group').find('.more-options').trigger('click');
				}
			});
		},
		
		initSorting: function() {
			$('#searchResultSortDropdown').change(function() {
				var sort = encodeURIComponent($(this).val());
				var url = $(this).data('url').replace('sort=SORT_FIELD', 'sort=' + sort);
				window.location = url;
			});
		},
		
		// Add To Cart Dialog
		initAddToCart: function() {
			$('form.product-add-to-cart').each(function(i, elem) {
				new C.AddToCart(elem);
			});
		},

		initCompare: function() {
			let compare_product_ids = Cookies.get('compare_product_ids')

			if (compare_product_ids) {
				compare_product_ids = compare_product_ids.split(',')

				for (var i = 0; i < compare_product_ids.length; i++) {
					let product_id = compare_product_ids[i]

					if ($("#product-compare-" + product_id).length) {
						$("#product-compare-" + product_id).prop('checked', true)
						$("#compare-label-" + product_id).hide()
						$("#compare-now-" + product_id).show()
					}
				}
			}
		},
		
		compareNow: function() {
			let compare_product_ids = Cookies.get('compare_product_ids').split(',')

			for (var i = 0; i < compare_product_ids.length; i++) {
				let productId = compare_product_ids[i]
				$('#productCompareForm').append($('<input>', { type: 'hidden', name: 'product_ids', value: $('<div>').text(productId).html() }))

			}

			let safeHref = $('<div>').text(window.location.href).html().replaceAll("&amp;", "&")
			$('#productCompareForm').append($('<input>', { type: 'hidden', name: 'prev_search_url', value: safeHref }))

			$("#productCompareForm").submit();
		},
		
		toggleCompare: function(product_id) {
			let compare_product_ids = Cookies.get('compare_product_ids')
			compare_product_ids = compare_product_ids ? compare_product_ids.split(',') : []

			if ($("#product-compare-"+product_id).prop('checked')) {
				$("#compare-label-"+product_id).hide()
				$("#compare-now-"+product_id).show()
				compare_product_ids.push(product_id)
			} else {
				$("#compare-now-"+product_id).hide()
				$("#compare-label-"+product_id).show()
				let removeIdx = compare_product_ids.indexOf(product_id)
				compare_product_ids.splice(removeIdx, 1)
			}

			Cookies.set('compare_product_ids', compare_product_ids.join(','))
		}
	};

	C.SearchPage = SearchPage;

})();
